import React, { useState } from 'react';
import { Box, Flex, Spinner } from '@chakra-ui/react';
import { Navigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { useAuth } from '../context/AuthContext';
import { TableDensityProvider } from '../context/TableDensityContext';
import { ProjectProvider } from '../context/ProjectContext';
import { UserProvider } from '../context/UserContext';
import { OrgProvider } from '../context/OrgContext';

export default function AppLayout({ children }) {
  const { loading, authenticated } = useAuth();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  if (loading) {
    return (
      <Flex minH="100vh" align="center" justify="center" bg="gray.50">
        <Spinner size="lg" color="brand.500" thickness="3px" />
      </Flex>
    );
  }

  if (!authenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return (
    <TableDensityProvider>
      <OrgProvider>
        <ProjectProvider>
          <UserProvider>
            <Box minH="100vh" bg="gray.50" overflowX="hidden" pt="64px">
              <Header onOpenMenu={() => setIsMobileMenuOpen(true)} />
              <Flex minH="calc(100vh - 64px)" overflow="hidden">
                <Sidebar
                  isMobileMenuOpen={isMobileMenuOpen}
                  onCloseMobileMenu={() => setIsMobileMenuOpen(false)}
                  collapsed={sidebarCollapsed}
                  setCollapsed={setSidebarCollapsed}
                />
                <Box
                  as="main"
                  flex={1}
                  p={{ base: 3, md: 6 }}
                  overflowX="auto"
                  minW={0}
                  ml={{ base: 0, md: sidebarCollapsed ? '72px' : '220px' }}
                  transition="margin-left 0.2s"
                >
                  {children}
                </Box>
              </Flex>
            </Box>
          </UserProvider>
        </ProjectProvider>
      </OrgProvider>
    </TableDensityProvider>
  );
}
